export const MAX_FILTER_SELECTION = 20;
